import React from "react"
import {DataTable} from "./DataTable"

const DataTables = React.memo((props) => {
  return (
    <>
      {props.tables.map((table, tableKey) => {
        return (
          <DataTable
            align="right"
            columns={props.columns}
            formula={table.formula}
            key={tableKey}
            name={table.name}
            renderValue={props.renderValue}
            rows={table.rows}
          />
        )
      })}
    </>
  )
})

export {DataTables}
